import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmService } from 'src/app/services/confirm.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { DialogAlterarSenhaComponent } from '../dialog-alterar-senha/dialog-alterar-senha.component';
import { DialogFotoPerfilComponent } from '../dialog-foto-perfil/dialog-foto-perfil.component';
import { DialogMeuPerfilComponent, MeuPerfil } from '../dialog-meu-perfil/dialog-meu-perfil.component';

export interface DialogPerfilUsuarioData {
  nome: string;
  administrador: boolean;
}

@Component({
  selector: 'app-dialog-perfil-usuario',
  templateUrl: './dialog-perfil-usuario.component.html',
  styleUrls: ['./dialog-perfil-usuario.component.css']
})
export class DialogPerfilUsuarioComponent implements OnInit {
  public nome: string;
  public nomeBaseDados = '';
  public fotoPerfilDisponivel = true;
  public fotoPerfilVersao = Date.now();
  public removendoFoto = false;
  public fotoAlterada = false;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogPerfilUsuarioData,
    private dialogRef: MatDialogRef<DialogPerfilUsuarioComponent>,
    private dialog: MatDialog,
    private httpClient: HttpClient,
    private confirmService: ConfirmService,
    private snackBarService: SnackBarService
  ) {
    this.nome = data.nome;
    this.dialogRef.backdropClick().subscribe(() => this.fechar());
  }

  public ngOnInit(): void {
    if (this.data.administrador) {
      this.nomeBaseDados = 'Carregando...';
      this.httpClient.get<{ nome: string }>('/api/Ambiente/BaseDados').subscribe({
        next: resultado => this.nomeBaseDados = resultado.nome || 'Não informada',
        error: () => this.nomeBaseDados = 'Indisponível'
      });
    }
  }

  public selecionarFoto(event: Event): void {
    const arquivo = (event.target as HTMLInputElement).files?.[0];
    if (!arquivo || this.removendoFoto) return;

    this.dialog.open(DialogFotoPerfilComponent, {
      autoFocus: false,
      data: { arquivoInicial: arquivo },
      width: '680px',
      maxWidth: 'calc(100vw - 32px)'
    }).afterClosed().subscribe(alterou => {
      if (alterou) {
        this.fotoPerfilDisponivel = true;
        this.fotoPerfilVersao = Date.now();
        this.fotoAlterada = true;
      }
    });
    (event.target as HTMLInputElement).value = '';
  }

  public removerFoto(event: MouseEvent): void {
    event.stopPropagation();
    this.confirmService.confirm('Deseja remover a foto de perfil?', 'Alerta', 'Remover').subscribe(confirmado => {
      if (!confirmado) return;
      this.removendoFoto = true;
      this.httpClient.delete('/api/Usuarios/MinhaFotoPerfil').subscribe({
        next: () => {
          this.removendoFoto = false;
          this.fotoPerfilDisponivel = false;
          this.fotoPerfilVersao = Date.now();
          this.fotoAlterada = true;
          this.snackBarService.exibirSucesso('Foto de perfil removida.');
        },
        error: () => {
          this.removendoFoto = false;
          this.snackBarService.exibirErro('Não foi possível remover a foto de perfil.');
        }
      });
    });
  }

  public abrirDados(): void {
    this.dialog.open(DialogMeuPerfilComponent, { autoFocus: false, disableClose: true, width: '520px', maxWidth: 'calc(100vw - 32px)' })
      .afterClosed().subscribe((perfil?: MeuPerfil) => {
        if (perfil?.noNomeCompleto) this.nome = perfil.noNomeCompleto;
      });
  }

  public abrirSenha(): void {
    this.dialog.open(DialogAlterarSenhaComponent, { autoFocus: false, disableClose: true, width: '420px', maxWidth: 'calc(100vw - 32px)' });
  }

  public sair(): void {
    this.dialogRef.close({ sair: true, nome: this.nome, fotoAlterada: this.fotoAlterada });
  }

  public fechar(): void {
    this.dialogRef.close({ nome: this.nome, fotoAlterada: this.fotoAlterada });
  }

  public onErroFotoPerfil(): void {
    this.fotoPerfilDisponivel = false;
  }

  public iniciaisUsuario(): string {
    return this.nome.trim().split(/\s+/).slice(0, 2).map(nome => nome[0]).join('').toUpperCase();
  }
}
